module.exports = __webpack_public_path__ + "static/media/gmail-reply-correct.5db2e9a3.png";